<template>
  <div class="warp">
    <el-form label-width="auto">
      <el-row :gutter="20">
        <el-descriptions :colon="false" :column="3" direction="vertical">
          <!--发件人-->
          <el-descriptions-item :label="$t('newOrder.SenderName')">
            <encryption-field
              field-name="senderName"
              :encrypted-value="senderInfo.senderName"
              :label="$t('newOrder.SenderName')"
            />
          </el-descriptions-item>
          <!--发件人公司-->
          <el-descriptions-item :label="$t('newOrder.SenderCompany')">
            <encryption-field
              field-name="senderCompany"
              :encrypted-value="senderInfo.senderCompany"
              :label="$t('newOrder.SenderCompany')"
            />
          </el-descriptions-item>
          <!--发件人手机-->
          <el-descriptions-item :label="$t('newOrder.senderPhone')">
            <encryption-field
              field-name="senderMobile"
              :encrypted-value="senderInfo.senderMobile"
              :label="$t('newOrder.senderPhone')"
            />
          </el-descriptions-item>
          <!--街道-->
          <el-descriptions-item :label="$t('newOrder.Street1')">
            <encryption-field field-name="senderStreet" :encrypted-value="senderInfo.senderStreet" :label="$t('newOrder.Street1')" />
          </el-descriptions-item>
          <!--发件人门牌号-->
          <el-descriptions-item :label="$t('newOrder.SenderNumber')">
            <encryption-field field-name="senderHouseNumber" :encrypted-value="senderInfo.senderHouseNumber" :label="$t('newOrder.SenderNumber')" />
          </el-descriptions-item>
          <!--发件人区-->
          <el-descriptions-item :label="$t('newOrder.SenderDistrict')">
            <encryption-field field-name="senderArea" :encrypted-value="senderInfo.senderArea" :label="$t('newOrder.SenderDistrict')" />
          </el-descriptions-item>
          <!--发件人城市-->
          <el-descriptions-item :label="$t('newOrder.SenderCity')">
            <div>{{ senderInfo.senderCity || '--' }}</div>
          </el-descriptions-item>
          <!--发件人州-->
          <el-descriptions-item :label="$t('newOrder.SenderState')">
            <div>{{ senderInfo.senderState || '--' }}</div>
          </el-descriptions-item>
          <!--发件人邮编-->
          <el-descriptions-item :label="$t('newOrder.SenderZipCode')">
            <div>{{ senderInfo.senderZipcode || '--' }}</div>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" :column="1" direction="vertical">
          <!--发件人地址补充-->
          <el-descriptions-item :label="$t('GlobalSetObj.sendderComplement')">
            <encryption-field
              field-name="senderComplement"
              :encrypted-value="senderInfo.senderComplement"
              :label="$t('GlobalSetObj.sendderComplement')"
            />
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" :column="3" direction="vertical">
          <!--发件人税号-->
          <el-descriptions-item :label="$t('newOrder.SenderCPFCNPJ')">
            <encryption-field
              field-name="senderTax"
              :encrypted-value="senderInfo.senderTax"
              :label="$t('newOrder.SenderCPFCNPJ')"
            />
          </el-descriptions-item>
          <!--国家注册号-->
          <el-descriptions-item :label="$t('GlobalSetObj.NationalRegistrationNumber')">
            <encryption-field field-name="senderIeNumber" :encrypted-value="senderInfo.senderIeNumber" :label="$t('GlobalSetObj.NationalRegistrationNumber')" />
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" :column="1" direction="vertical">
          <!--发件地址-->
          <el-descriptions-item :label="$t('newOrder.SendingAddress')">
            <encryption-field
              field-name="senderAddress"
              :encrypted-value="senderInfo.senderAddress"
              :label="$t('newOrder.SendingAddress')"
            />
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :colon="false" :column="3" direction="vertical">
          <!--发件人电话-->
          <el-descriptions-item :label="$t('newOrder.SenderPhone')">
            <encryption-field
              field-name="senderPhone"
              :encrypted-value="senderInfo.senderPhone"
              :label="$t('newOrder.SenderPhone')"
            />
          </el-descriptions-item>
          <!--发件人邮箱-->
          <el-descriptions-item :label="$t('newOrder.SenderEmail')">
            <encryption-field
              field-name="senderMail"
              :encrypted-value="senderInfo.senderMail"
              :label="$t('newOrder.SenderEmail')"
            />
          </el-descriptions-item>
        </el-descriptions>
      </el-row>
    </el-form>
  </div>
</template>

<script>

export default {
  name: 'SenderInfo',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    'encryption-field': () => import('@/components/EncryptionField/index.vue')
  },
  props: {
    senderInfo: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    encryptionSenderInfo: {
      type: Object,
      required: true,
      default: () => {
      }
    }
  },
  data() {
    return {
      showDetail: true,
      showDetail1: true,
      showDetail2: true,
      showDetail3: true,
      showDetail4: true,
      showDetail5: true,
      showDetail6: true,
      showDetail7: true
    };
  },
  methods: {
    handlerhidden(item, value) {
      const buttonPermissions = this.$store.getters.button_permissions;
      const promise = 'field:customer-sensitive-info';
      const hasPromise = buttonPermissions.includes(promise);
      if (hasPromise) {
        if (item === 'name') {
          this.showDetail = !this.showDetail;
        }
        if (item === 'senderPhone') {
          this.showDetail1 = !this.showDetail1;
        }
        if (item === 'senderMobile') {
          this.showDetail2 = !this.showDetail2;
        }
        if (item === 'senderMail') {
          this.showDetail3 = !this.showDetail3;
        }
        if (item === 'senderTax') {
          this.showDetail4 = !this.showDetail4;
        }
        if (item === 'senderCompany') {
          this.showDetail5 = !this.showDetail5;
        }
        if (item === 'senderAddress') {
          this.showDetail6 = !this.showDetail6;
        }
        if (item === 'senderComplement') {
          this.showDetail7 = !this.showDetail7;
        }
      } else {
        this.$message.error(this.$t('GlobalSetObj.sensitiveInfoPermission'));
      }
    }
  }
};
</script>

<style scoped>
.warp /deep/ .el-col {
  height: 50px;
}

.iconEye {
  cursor: pointer;
  margin-left: 10px;
}

.warp /deep/ .el-descriptions-item__label {
  font-size: 13px;
  color: #909399;
}

.warp /deep/ .el-descriptions-item__cell {
  /*height: 35px !important;*/
  padding-bottom: 2px !important;
}

.el-descriptions-item__cell div {
  font-weight: bold;
  font-size: 15px;
}
</style>
